/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Food Truck',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M16.867 4.586a1.5 1.5 0 0 1 1.5 1.5v.629c-.006-.005-.014-.009-.02-.015a.5.5 0 0 1 .138.166l1.264 2.528a3.75 3.75 0 0 1 3.598 3.747v2.691a.75.75 0 0 1-.75.75h-1.375l.004.071-.015.282a2.76 2.76 0 0 1-2.744 2.477l-.281-.015a2.76 2.76 0 0 1-2.477-2.744l.003-.068H8.81l.003.068-.015.282a2.76 2.76 0 0 1-2.744 2.477l-.281-.015a2.76 2.76 0 0 1-2.477-2.744c0-.06.006-.12.01-.179l-.183-.089c-.41-.234-.698-.655-.748-1.147l-.008-.153V10.59H1.155a.5.5 0 0 1-.447-.724l1.5-3a.5.5 0 0 1 .16-.186v-.595a1.5 1.5 0 0 1 1.5-1.5h13zM6.054 15.097a1.56 1.56 0 0 0-1.558 1.558 1.56 1.56 0 0 0 1.558 1.559 1.56 1.56 0 0 0 1.559-1.559 1.56 1.56 0 0 0-1.559-1.558zm12.412 0a1.56 1.56 0 0 0-1.558 1.558 1.56 1.56 0 0 0 1.558 1.559 1.56 1.56 0 0 0 1.559-1.559 1.56 1.56 0 0 0-1.559-1.558zm-14.898-.011c0 .082.033.157.087.211.474-.836 1.37-1.4 2.399-1.4 1.083 0 2.018.627 2.47 1.535l-.021-.046h7.517a2.77 2.77 0 0 1 1.148-1.164v-1.482h-13.6v2.347zm14.823-1.187l.075-.003c1.065 0 1.987.604 2.447 1.487h1.232v-2.086h-2.704a.6.6 0 0 1-.6-.6v-2.106h-.451v3.308zm1.65-1.801h1.88a2.55 2.55 0 0 0-1.88-1.466v1.466zm-16.474-.559h13.6v-.949h-13.6v.949zM2.288 9.39h16.115l-.8-1.6H3.088l-.8 1.6zm1.579-3.604a.3.3 0 0 0-.3.3v.504h13.6v-.504a.3.3 0 0 0-.3-.3h-13z"
            fill="currentColor"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
